import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const KurumsalPage = lazy(() => import('../pages/kurumsal/page'));
const ReferanslarPage = lazy(() => import('../pages/referanslar/page'));
const IletisimPage = lazy(() => import('../pages/iletisim/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// OSGB Pages
const IsGuvenligiUzmaniPage = lazy(() => import('../pages/osgb/is-guvenligi-uzmani/page'));
const IsyeriHekimiPage = lazy(() => import('../pages/osgb/isyeri-hekimi/page'));
const DigerSaglikPersoneliPage = lazy(() => import('../pages/osgb/diger-saglik-personeli/page'));
const RiskDegerlendirmesiPage = lazy(() => import('../pages/osgb/risk-degerlendirmesi/page'));

// Eğitim Pages
const IsgTemelEgitimiPage = lazy(() => import('../pages/egitimler/isg-temel-egitimi/page'));
const YanginEgitimiPage = lazy(() => import('../pages/egitimler/yangin-egitimi/page'));
const IlkyardimEgitimiPage = lazy(() => import('../pages/egitimler/ilkyardim-egitimi/page'));
const YuksekteCalismaEgitimiPage = lazy(() => import('../pages/egitimler/yuksekte-calisma-egitimi/page'));
const AcilDurumEgitimleriPage = lazy(() => import('../pages/egitimler/acil-durum-egitimleri/page'));
const MeslekEgitimiPage = lazy(() => import('../pages/egitimler/meslek-egitimi/page'));

// Laboratuvar Pages
const HizmetLaboratuvariPage = lazy(() => import('../pages/laboratuvar/hizmet-laboratuvari/page'));
const IseGirisSaglikRaporuPage = lazy(() => import('../pages/laboratuvar/ise-giris-saglik-raporu/page'));
const MobilSaglikAraciPage = lazy(() => import('../pages/laboratuvar/mobil-saglik-araci/page'));

// Danışmanlık Pages
const CevreDanismanligiPage = lazy(() => import('../pages/danismanlik/cevre-danismanligi/page'));
const OrtamOlcumleriPage = lazy(() => import('../pages/danismanlik/ortam-olcumleri/page'));
const PeriyodikKontrollerPage = lazy(() => import('../pages/danismanlik/periyodik-kontroller/page'));
const TehlikeliMaddePage = lazy(() => import('../pages/danismanlik/tehlikeli-madde/page'));
const HirdavatKkdPage = lazy(() => import('../pages/danismanlik/hirdavat-kkd/page'));
const PkdAtexPage = lazy(() => import('../pages/danismanlik/pkd-atex/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kurumsal',
    element: <KurumsalPage />,
  },
  {
    path: '/referanslar',
    element: <ReferanslarPage />,
  },
  {
    path: '/iletisim',
    element: <IletisimPage />,
  },
  // OSGB Routes
  {
    path: '/osgb/is-guvenligi-uzmani',
    element: <IsGuvenligiUzmaniPage />,
  },
  {
    path: '/osgb/isyeri-hekimi',
    element: <IsyeriHekimiPage />,
  },
  {
    path: '/osgb/diger-saglik-personeli',
    element: <DigerSaglikPersoneliPage />,
  },
  {
    path: '/osgb/risk-degerlendirmesi',
    element: <RiskDegerlendirmesiPage />,
  },
  // Eğitim Routes
  {
    path: '/egitimler/isg-temel-egitimi',
    element: <IsgTemelEgitimiPage />,
  },
  {
    path: '/egitimler/yangin-egitimi',
    element: <YanginEgitimiPage />,
  },
  {
    path: '/egitimler/ilkyardim-egitimi',
    element: <IlkyardimEgitimiPage />,
  },
  {
    path: '/egitimler/yuksekte-calisma-egitimi',
    element: <YuksekteCalismaEgitimiPage />,
  },
  {
    path: '/egitimler/acil-durum-egitimleri',
    element: <AcilDurumEgitimleriPage />,
  },
  {
    path: '/egitimler/meslek-egitimi',
    element: <MeslekEgitimiPage />,
  },
  // Laboratuvar Routes
  {
    path: '/laboratuvar/hizmet-laboratuvari',
    element: <HizmetLaboratuvariPage />,
  },
  {
    path: '/laboratuvar/ise-giris-saglik-raporu',
    element: <IseGirisSaglikRaporuPage />,
  },
  {
    path: '/laboratuvar/mobil-saglik-araci',
    element: <MobilSaglikAraciPage />,
  },
  // Danışmanlık Routes
  {
    path: '/danismanlik/risk-degerlendirmesi',
    element: <RiskDegerlendirmesiPage />,
  },
  {
    path: '/danismanlik/cevre-danismanligi',
    element: <CevreDanismanligiPage />,
  },
  {
    path: '/danismanlik/ortam-olcumleri',
    element: <OrtamOlcumleriPage />,
  },
  {
    path: '/danismanlik/periyodik-kontroller',
    element: <PeriyodikKontrollerPage />,
  },
  {
    path: '/danismanlik/tehlikeli-madde',
    element: <TehlikeliMaddePage />,
  },
  {
    path: '/danismanlik/hirdavat-kkd',
    element: <HirdavatKkdPage />,
  },
  {
    path: '/danismanlik/pkd-atex',
    element: <PkdAtexPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
